import { render, staticRenderFns } from "./LiefengTableNew.vue?vue&type=template&id=318955e5&scoped=true&"
import script from "./LiefengTableNew.vue?vue&type=script&lang=js&"
export * from "./LiefengTableNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318955e5",
  null
  
)

export default component.exports